import * as React from 'react';
import LayoutGrid from '@tunnel-components/layouts/layout/index';
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import OngletIncident from "@tunnel-components/@sharded/widgets/onglet-navigation/component";
import InhibitionGrid from "@tunnel-components/@sharded/widgets/box/inhibitions/component";
import InhibitionCameraGrid from "@tunnel-components/@sharded/widgets/box/inhibition-camera/component";
import Slider from "@tunnel-components/@sharded/@widgets/slider";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import * as Utils from '@Cyclope-Utils/index';
import * as Enums from '@tunnel-enums/index';
import * as Lodash from 'lodash';
import * as Paths from '@tunnel-enums/index';
import * as moment from 'moment';
import MessageEmptyInibitions from '@tunnel-components/@sharded/message-inhibition/component';
import MessageEmptyIncidents from '@tunnel-components/@sharded/message/component';

import * as i18next from 'i18next';

/** 
 * @function Component : Composant fonctionnel 
 * @description : fonction simple qui prend en argument un objet props 
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface } 
 * @type { React.FunctionComponent } 
 * @infos "https://reactjs.org" 
 */
const Component: React.FunctionComponent<any> = (props: ComponentInterface): JSX.Element => {

    /**
     * @affectation
     * @description : 
     * Affectation par décomposition des élements de l'objet (props)
     * les élements existent ou sont créés dans ( ou par) la @class container
     * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
     * susceptibles de subir une affectation par décomposition
     * exemple : const { elements } = objet ;
     * @infos "https://developer.mozilla.org"
     */
    // desturation
    const { onClickOnglet ,noInhibitionCameras, allcamera  ,ongletActive, onClickOngletCameras, onInhibitionRemove , ongletActiveCameras  ,inhibition , onOpenInhibitionModal, onCloseInhibitionModal  ,loading ,data  ,btnloading ,errorserver ,noIncidents } = props;
    /** Configuration dela viriable globale , L'objet window représente une fenêtre contenant un document DOM   */
    const API_URL = 'env'; 
    /**
     * @description : retourne un objet ( utilisateur )
     * @const
     * @name User
     * @type { any  }
     */
    const User : any = Utils.createdUserRoles();

    /**
     * @description : retourne un boolean
     * @const
     * @name authorization
     * @type { boolean  }
     */
    const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User,[Enums.AuthorizationRightsEnums.INHIBITIONCREATED]);
    const authCameraListInhibition: boolean = Utils.simpleAuthorizationIsAllowed(User,[Enums.AuthorizationRightsEnums.INHIBITIONSEECAMERASINHIBITION]);
        
    /**
     * @description : retourne un boolean ( )
     * @const
     * @name siteLoading
     * @type { boolean  }
     */
    const  siteLoading : boolean = !Lodash.isUndefined(data) && !Lodash.isEmpty(data) && !Lodash.isNull(data);
    /**
     * @description : retourne un boolean ( )
     * @const
     * @name camerainhibitionLoading
     * @type { boolean  }
     */
    const camerainhibitionLoading : boolean = !Lodash.isUndefined(allcamera) && !Lodash.isEmpty(allcamera) && !Lodash.isNull(allcamera);
    /**
     * @description : la largeur des cartes
     * @const
     * @name widthCart
     * @type { string  }
     */
    const widthCart: number = Math.ceil(Utils.fullWidthContent() * 0.324 ) ;  // Math.ceil(Utils.fullWidthContent() * 0.324) ;
     
    /**
     * @description : retourne un tableau
     * @const
     * @name onglet
     * @type { string[]  }
     */

    const onglet : any[] = [
        {
            title: i18next.t("toutes"),
            action:""
        },
        {
            title: i18next.t("en cours"),
            action:""
        },
        {
            title: i18next.t("a venir"),
            action:""
        },
        {
            title:i18next.t("terminees"),
            action:""
        }
    ];
    
    
    /**
     * @description : retourne un tableau
     * @const
     * @name ongletCameras
     * @type { string[]  }
     */

    const ongletCameras : any[] = [
        {
            title: i18next.t("toutes"),
            action:""
        },
        {
            title: i18next.t(window[API_URL].TUBE_O1),
            action:""
        },
        {
            title: i18next.t(window[API_URL].TUBE_O2),
            action:""
        },
        {
            title: i18next.t(window[API_URL].TUBE_O3),
            action:""
        }
    ]
    /**
     * @description : retourne un string ( environnement) 
     * @const
     * @name API_URL
     * @type { string  }
     */
    const ALLCAMERA: any = Utils.transformObjectToArray(allcamera); 
    /**
     * @description : retourne un string ( environnement) 
     * @const
     * @name allTube
     * @name tubeNord
     * @name tubeSud
     * @name tubeTLB
     */
    const allTube: boolean = ALLCAMERA && Lodash.isEmpty(ALLCAMERA.filter( (elem: any) => elem !== null));
    const tubeNord: boolean = ALLCAMERA && Lodash.isEmpty(ALLCAMERA.filter( (elem: any) => elem.camera && elem.camera.section && elem.camera.section.id === 1 ));
    const tubeSud: boolean = ALLCAMERA && Lodash.isEmpty(ALLCAMERA.filter( (elem: any) => elem.camera && elem.camera.section && elem.camera.section.id === 2 ));
    const tubeTLB: boolean = ALLCAMERA && Lodash.isEmpty(ALLCAMERA.filter( (elem: any) => elem.camera && elem.camera.section && elem.camera.section.id === 3 ));
  

   
    /**
     * @description : retourne un string ( environnement) 
     * @function
     * @name breadCrumFunction
     */
    const breadCrumFunction: any  = (): string => {
        /**
         * @description : retourne un string ( environnement) 
         * @const
         * @name breadCrum
         * @type { string  }
         */
        let breadCrum: string = "";

        if(ongletActive[0]){ breadCrum = i18next.t("toutes") }
        else if(ongletActive[1]){ breadCrum = i18next.t("en cours") }
        else if(ongletActive[2]){ breadCrum = i18next.t("a venir")}
        else if(ongletActive[3]){ breadCrum = i18next.t("terminees")}

        return breadCrum;
    }

    /**
     * @description : retourne un string ( environnement) 
     * @const
     * @name inThisTimes
     * @name outOfTimes
     * @name inNextTimes
     */
    const inThisTimes: boolean = data && Lodash.isEmpty(Utils.transformObjectToArray(data).filter( (elem: any) => elem !== null &&   moment(elem.starttime) <= moment() && moment(elem.endtime) >= moment()));
    const outOfTimes: boolean = data && Lodash.isEmpty(Utils.transformObjectToArray(data).filter( (elem: any) => elem !== null &&   moment(elem.starttime) < moment() && moment(elem.endtime) < moment()));
    const inNextTimes: boolean = data && Lodash.isEmpty(Utils.transformObjectToArray(data).filter( (elem: any) => elem !== null &&   moment(elem.starttime) > moment() && moment(elem.endtime) > moment()));
    
    /**
     * @expression return()
     * @description : 
     * Cette expression transforme un élément JSX en élément HTML
     * @external
     * @name lodash
     * @infos "https://reactjs.org" 
     */
    return (

        <LayoutGrid   error={errorserver} inhibition={inhibition} onCloseInhibitionModal={onCloseInhibitionModal}  btnloading={btnloading} loading={loading} authorization={authorization}  >
        
            
        
            
                <section className="tunnel-site animated fadeIn">
                    {siteLoading &&  !noIncidents && <BreadCrumb iconSupervision={true} links1={Paths.PathsNamesEnums.INHIBITIONS} title={i18next.t("supervision")} breadText1={i18next.t("inhibition")} breadText2={breadCrumFunction()} addIhnibition={!noIncidents && authorization} onOpenInhibitionModal={onOpenInhibitionModal}/>  } 
                    
                    <div className="inhibitionespace" style={{position:"relative",width:"100%",margin:"5px 0"}}/>
                    <div className="contentAllSite contentInhibition">
                        <section id="columns" className="with-3-columns">
                            <section className="content-wrapper">

                                    
                               
                                    <Styled.inhibitionContentCarousel style={{height:"55%"}}> 

                                        { !noIncidents && siteLoading &&  <OngletIncident someTitle="Inhibition" onglet={onglet} onClickOnglet={onClickOnglet} ongletActive={ongletActive}/>}
                                        { ongletActive[0] && !noIncidents && siteLoading &&  <Slider  widthCart={widthCart } style={{height:"calc(100% - 33px)"}} item={data && Utils.transformObjectToArray(data)} Cart={InhibitionGrid}  authorization={authorization} onInhibitionRemove={onInhibitionRemove}/>}
                                        { ongletActive[1] && !noIncidents && siteLoading && !inThisTimes &&  <Slider  widthCart={widthCart } style={{height:"calc(100% - 33px)"}} item={data && Utils.transformObjectToArray(data).filter( (elem: any) => elem !== null &&  moment(elem.starttime) <= moment() && moment(elem.endtime) >= moment())} Cart={InhibitionGrid}  authorization={authorization} onInhibitionRemove={onInhibitionRemove}/>}
                                        { ongletActive[2] && !noIncidents && siteLoading && !inNextTimes &&  <Slider  widthCart={widthCart } style={{height:"calc(100% - 33px)"}} item={data && Utils.transformObjectToArray(data).filter( (elem: any) => elem !== null &&  moment(elem.starttime) > moment() && moment(elem.endtime) > moment())} Cart={InhibitionGrid}  authorization={authorization} onInhibitionRemove={onInhibitionRemove}/>}
                                        { ongletActive[3] && !noIncidents && siteLoading && !outOfTimes &&  <Slider  widthCart={widthCart } style={{height:"calc(100% - 33px)"}} item={data && Utils.transformObjectToArray(data).filter( (elem: any) => elem !== null &&  moment(elem.starttime) < moment() && moment(elem.endtime) < moment())} Cart={InhibitionGrid}  authorization={authorization} onInhibitionRemove={onInhibitionRemove}/>}
                                        { noIncidents && !siteLoading &&  <MessageEmptyInibitions message={i18next.t("actuellement, il ny a pas dinhibition")} onAddInhibition={onOpenInhibitionModal} authorizationInibition={authorization}/> }

                                        { /** Message */}
                                        { ongletActive[1] && data && inThisTimes && < MessageEmptyIncidents message={i18next.t("pas d'inhibition en cours")}/>}
                                        { ongletActive[2] && data && inNextTimes && < MessageEmptyIncidents message={i18next.t("pas d'inhibition a venir")}/>}
                                        { ongletActive[3] && data && outOfTimes && < MessageEmptyIncidents message={i18next.t("Pas d'inhibition terminées")}/>}

                                    </Styled.inhibitionContentCarousel>
                                    {
                                        authCameraListInhibition &&
                                        <Styled.inhibitionContentCarousel style={{height:"45%"}}>
                                        {!noInhibitionCameras && camerainhibitionLoading &&<OngletIncident someTitle="Caméras" onglet={ongletCameras} onClickOnglet={onClickOngletCameras} ongletActive={ongletActiveCameras}/>}
                                       
                                        { ongletActiveCameras[0] && !noInhibitionCameras && camerainhibitionLoading && !allTube && <Slider style={{height:"calc(100% - 33px)"}} item={ALLCAMERA} Cart={InhibitionCameraGrid} widthCart={widthCart } authorization={authorization} onInhibitionRemove={onInhibitionRemove}/>}
                                        { ongletActiveCameras[1] && !noInhibitionCameras && camerainhibitionLoading && !tubeNord && <Slider style={{height:"calc(100% - 33px)"}} item={ALLCAMERA.filter( (elem: any) => elem.camera && elem.camera.section && elem.camera.section.id === 1 )} Cart={InhibitionCameraGrid} widthCart={widthCart } authorization={authorization} onInhibitionRemove={onInhibitionRemove}/>}
                                        { ongletActiveCameras[2] && !noInhibitionCameras && camerainhibitionLoading && !tubeSud && <Slider style={{height:"calc(100% - 33px)"}} item={ALLCAMERA.filter( (elem: any) => elem.camera && elem.camera.section && elem.camera.section.id === 2  )} Cart={InhibitionCameraGrid} widthCart={widthCart } authorization={authorization} onInhibitionRemove={onInhibitionRemove}/>}
                                        { ongletActiveCameras[3] && !noInhibitionCameras && camerainhibitionLoading && !tubeTLB && <Slider style={{height:"calc(100% - 33px)"}} item={ALLCAMERA.filter( (elem: any) => elem.camera && elem.camera.section && elem.camera.section.id === 3 )} Cart={InhibitionCameraGrid} widthCart={widthCart } authorization={authorization} onInhibitionRemove={onInhibitionRemove}/>}

                                        { ongletActiveCameras[0] && !noInhibitionCameras && camerainhibitionLoading && allTube && < MessageEmptyIncidents message={i18next.t("pas d'inhibition sur les cameras")}/>}
                                        { ongletActiveCameras[1] && !noInhibitionCameras && camerainhibitionLoading && tubeNord && < MessageEmptyIncidents message={i18next.t("pas d'inhibition sur les cameras de la section")}/>}
                                        { ongletActiveCameras[2] && !noInhibitionCameras && camerainhibitionLoading && tubeSud && < MessageEmptyIncidents message={i18next.t("pas d'inhibition sur les cameras de la section")}/>}
                                        { ongletActiveCameras[3] && !noInhibitionCameras && camerainhibitionLoading && tubeTLB && < MessageEmptyIncidents message={i18next.t("pas d'inhibition sur les cameras de la section")}/>}
                                
                                      { noInhibitionCameras &&  <MessageEmptyInibitions message={i18next.t("actuellement, il ny a pas dinhibition sur les camera")} visualizationCamera={true} links={Paths.PathsNamesEnums.CAMERAHOME}/> }
                                    </Styled.inhibitionContentCarousel>}
                                    
                            </section>
                        </section>
                    </div>
                    
                </section> 
            
        </LayoutGrid>            

    )

}
/** Valeurs par défaut des props */
Component.defaultProps = {
       
    inhibition: true,
    
}

/**
 * @interface ComponentInterface
 * @description : 
 * Cette interface définit le model du props
 */
interface ComponentInterface{
    
    onClickOnglet ?:any , 
    ongletActive  ?:any ,
    inhibition?:any , 
    onOpenInhibitionModal ?:any , 
    onInhibitionRemove?:any ,
    loading?:any ,
    data ?:any ,
    btnloading ?:any,
    errorserver ?:any,
    noIncidents ?:any,
    onCloseInhibitionModal?:any,
    ongletActiveCameras?:any,
    onClickOngletCameras?:any,
    allcamera?:any,
    noInhibitionCameras?:boolean,

}

/** @export HOC pure */
export default React.memo(Component);


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/inhibitions/home/component.tsx